import { observer } from "mobx-react-lite";
import { useExonnHubCatalogParams } from "src/admin/modules/b2b-gate-order/components/ExonnHub/hooks/useExonnHubCatalogParams.ts";
import { useExonnHubCatalog } from "src/admin/modules/b2b-gate-order/components/ExonnHub/hooks/useExonnHubCatalog.tsx";
import { keepPreviousData } from "@tanstack/react-query";
import type { ExonnHubFilterDefinition } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHub.types.ts";
import { CheckboxFilter } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/FiltersView/CheckboxFilter/CheckboxFilter.tsx";
import * as styles from "./FiltersList.style.ts";
import { RangeFilter } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/FiltersView/RangeFilter/RangeFilter.tsx";
import { PINNED_DOWN_FILTERS } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHub.constants.ts";

const EXCLUDE_FILTERS = PINNED_DOWN_FILTERS;

export const FiltersList = observer(() => {
  const listParams = useExonnHubCatalogParams();

  const { data: catalogData } = useExonnHubCatalog(listParams, {
    placeholderData: keepPreviousData,
  });

  const filters = (catalogData?.filters || []).map((filter) => {
    if (filter.type === "range") {
      return {
        ...filter,
        min: Math.floor(filter.min),
        max: Math.ceil(filter.max),
      };
    }
    return filter;
  });

  return (
    <div css={styles.root}>
      {filters.map((filter: ExonnHubFilterDefinition) => {
        if (EXCLUDE_FILTERS.includes(filter.name)) {
          return null;
        }
        if (filter.type === "checkbox") {
          return <CheckboxFilter filter={filter} />;
        }
        if (filter.type === "range") {
          return <RangeFilter filter={filter} />;
        }
        return null;
      })}
    </div>
  );
});
